var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import * as RelatedCollectionFactory from '../../../classes/definitions/relatedCollection/relatedCollection';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import relatedCollectionSchema from "../../../schemas/relatedCollectionSchema";
import Input from '../../UI/Input/Input';
var RelatedCollectionForm = /** @class */ (function (_super) {
    __extends(RelatedCollectionForm, _super);
    function RelatedCollectionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.staticPageId = '';
        _this.productId = '';
        _this.state = {
            formConfig: _.cloneDeep(relatedCollectionSchema),
            formIsValid: false,
            discardPopupVisble: false,
            productsSuggestions: []
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = event.value;
                }
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedRelatedCollection = RelatedCollectionFactory.createRelatedCollection({
                position: _.get(formData, 'position.value', 0),
                product: Number(_.get(formData, 'product.value.value', null)),
            });
            _this.api.createRelatedCollection(_this.productId, { "related_collection": submittedRelatedCollection })
                .then(function (response) {
                _this.toRelatedCollectionsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на запис';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toRelatedCollectionsPage = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.productId + AppRoutes.relatedCollections.path);
        };
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            _this.api.searchProducts(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: _.get(item, 'attributes.name', ''),
                        value: _.get(item, 'id')
                    });
                }
                var obj = {};
                obj['productsSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        return _this;
    }
    RelatedCollectionForm.prototype.componentDidMount = function () {
        this.productId = _.get(this.props, 'match.params.id', '-1');
    };
    RelatedCollectionForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, productsSuggestions = _a.productsSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key
                });
            }
        }
        // Building form inputs
        var form = (formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType); }, suggestions: productsSuggestions, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); } }));
        }));
        var actionBtns = React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toRelatedCollectionsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK"));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
            form,
            actionBtns));
    };
    return RelatedCollectionForm;
}(React.Component));
// @ts-ignore
export default withRouter(RelatedCollectionForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/RelatedCollections/RelatedCollectionForm/RelatedCollectionForm.tsx
// module id = 429
// module chunks = 0